// src/components/CardList.js

// src/components/CardList.js
import React from 'react';
import BusinessCard from './BusinessCard';
import './CardList.styles.scss';

const CardList = ({ items }) => {
  return (
    <div className="business-list">
      {items.map(business => (
        <BusinessCard
          key={business.attributes.FID}
          business={business}
        />
      ))}
    </div>
  );
};

export default CardList;

